import { showPopup } from "./popups";
import Confirm from "./Confirm.vue";
import { ConfirmPopupParams } from "./types";

export const showConfirmPopup = (
  params: ConfirmPopupParams
): Promise<boolean | null> => {
  return showPopup(Confirm, params, true);
};
